import './publicpath.js'
/* TODO: investigate on this dependency  */
import 'intersection-observer'
import VueThinModal from 'vue-thin-modal'
import Vuelidate from 'vuelidate'
import Vuex from 'vuex'
import VueMq from 'vue-mq'
import VScrollLock from 'v-scroll-lock'
import VueMultianalytics from '@/scripts/libs/vue-multianalytics'
import TealiumTrackingModule from './libs/tracking/tealium'
import checkView from 'vue-check-view'

import { Media } from './libs/media/media'
import { GlobalCta } from './directive/global-cta'
import { MenuMouseEnter, MenuMouseLeave } from '@/elements/header/directives.js'
import { registerGenerateForm } from '@/scripts/libs/generate-form'

import Vue2TouchEvents from 'vue2-touch-events'

import { MOBILE, TABLET } from '@/scripts/constants/media-query'

import createStore from './store'

import { UPDATE_LABELS } from './store/labels.js'
import { getLabelsJSON } from './libs/data.js'

import './libs/utilsAxios'

import VueI18n from 'vue-i18n'
import i18n from '@/scripts/libs/i18n'

const ExposedRayBanApi = require('./exposed-api/exposed-api.ts')

import Vue from 'vue'
import VViewport from '@/scripts/directive/v-viewport.js'

import wcs from '@/scripts/libs/wcs'

const initVueMachine = () => {
  Vue.directive('cta', GlobalCta)
  Vue.directive('menu-mouse-enter', MenuMouseEnter)
  Vue.directive('menu-mouse-leave', MenuMouseLeave)
  Vue.directive('viewport', VViewport)

  Vue.use(Vuex)
  Vue.use(Vuelidate)
  Vue.use(VueMq, {
    breakpoints: Media.breakpoints,
    defaultBreakpoint: MOBILE,
  })
  Vue.use(VScrollLock, { bodyScrollOptions: { reserveScrollBarGap: true } })
  Vue.use(VueThinModal, {
    autoMountPortal: false,
  })

  // Setup Tracking Library
  VueMultianalytics.addCustomModule('tealium', TealiumTrackingModule)
  Vue.use(VueMultianalytics, {
    modules: {
      tealium: {
        /* module config */
      },
    },
  })

  Vue.use(Vue2TouchEvents)

  Vue.use(checkView)

  Vue.use(VueI18n)

  const store = createStore(Vuex)

  store.commit(`${UPDATE_LABELS}`, getLabelsJSON())

  if (!window.externalInvocationMethodMapping) {
    window.externalInvocationMethodMapping = {}
  }

  window.triggerVueMethod = function (methodName, ...args) {
    if (window.externalInvocationMethodMapping[methodName]) {
      window.externalInvocationMethodMapping[methodName].apply(null, args)
    }
  }

  ExposedRayBanApi.registerExposedMethods(store)
  registerGenerateForm()

  return store
}

const startVueMachine = (store) => {
  const i18nInstance = i18n?.setupLocalization()
  const $els = document.querySelectorAll('[data-vue="app"]')
  $els.forEach(($el) => {
    new Vue({
      el: $el,
      store,
      i18n: i18nInstance,
      provide() {
        return {
          overrideSlidesPerView: null,
          overrideAlwaysShowSwiper: false,
          overrideColumnsOfNextSlide: null,
        }
      },
      computed: {
        mainClasses() {
          return {
            loaded: true,
            'menu-open': !!this.$store.state.navigationMenu.showMenuId,
            'promo-stripes': !!this.$store.state.ui.isHeaderPromo,
            'rb-app__main--background':
              !!this.$store.state.header.isInBackground && !this.$store.state.eyeMedIsVisible,
            'rb-app__footer--foreground':
              !!this.$store.state.sidebar.cart.show ||
              !!this.$store.state.sidebar.wishlist.show ||
              !!this.$store.state.virtualMirror.isVisible,
            'rb-app__footer--background': this.$store.state.eyeMedIsVisible,
            'rb-app__footer--rox-frame-active':
              this.isMobile &&
              !!this.$store.state.frameGenius.isFrameAdvisorOpen &&
              !!this.$store.state.pdp.isRoxPanelRendered,
          }
        },
        isMobile() {
          return [MOBILE, TABLET].includes(this.$mq)
        },
        isPcpMobile() {
          return this.isMobile && wcs.isInFluidPcp()
        },
      },
    })
  })
}

export const initAndStartVueMachine = () => {
  const store = initVueMachine()
  startVueMachine(store)
}
